import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

const FAQSection = () => {
  const [items, setItems] = useState([]);
  const [faq, setFAQsection] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  // Fetch FAQ section data
  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/faq`)
      .then((res) => res.json())
      .then((info) => setFAQsection(info));
  }, []);

  // Fetch FAQ items data
  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/faq-items`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);

  // Accordion toggle handler
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {faq.slice(0, 1).map((section) => (
        <section className="faq-style-three pb_140 pt_100 modern-home-section" key={section._id}>
          <div
            className="pattern-layer"
            style={{ backgroundImage: "url(assets/images/shape/shape-44.png)" }}
          />
          <div className="auto-container">
            <div className="modern-section-heading text-center">
              <span className="sub-title">{section.faqText}</span>
              <h2>{section.faqHeading}</h2>
              <p>Answers to the most common questions about setup, support, and how AuraWeb automation works.</p>
            </div>

            <div className="row clearfix align-items-center g-4">
              <div className="col-lg-5 col-md-12 col-sm-12 image-column">
                <div className="modern-faq-sidecard">
                  <figure className="image">
                    <img src={section.faqImage} alt="FAQ illustration" />
                  </figure>
                  <div className="modern-faq-sidecard-copy">
                    <h3>Need a tailored walkthrough?</h3>
                    <p>Book a quick demo and we will show exactly how the automation fits your business.</p>
                    <Link to="/contact-us" className="theme-btn btn-one">
                      Book a Free Demo
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-7 col-md-12 col-sm-12 content-column">
                <div className="inner-box">
                  <ul className="accordion-box modern-faq-list">
                    {items.map((item, index) => (
                      <li className={`accordion block modern-faq-item ${activeIndex === index ? "active" : ""}`} key={item._id}>
                        <button
                          type="button"
                          className={`acc-btn ${activeIndex === index ? "active" : ""}`}
                          onClick={() => toggleAccordion(index)}
                          aria-expanded={activeIndex === index}
                        >
                          <span>{item.accodingTitle}</span>
                          <strong>{activeIndex === index ? "−" : "+"}</strong>
                        </button>
                        <div
                          className="acc-content"
                          style={{ display: activeIndex === index ? "block" : "none" }}
                        >
                          <div className="text">
                            <p>{item.accodingText}</p>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default FAQSection;
